import React from 'react';
import { connect } from 'react-redux';
import { IconChatUnread } from '../../../base/icons/svg';
import { translate } from '../../../base/i18n/functions';
import Button from '../../../base/ui/components/web/Button';
import { BUTTON_TYPES } from '../../../base/ui/constants.any';
/**
 * Label for the conference name.
 *
 * @returns {ReactElement}
 */
const TranscriptLink = ({ _transcriptionLink, _conference, t }) => {
    const onClick = () => {
        window.open(_transcriptionLink, '_blank');
    };
    if (_transcriptionLink && _transcriptionLink !== '') {
        return (React.createElement(Button, { accessibilityLabel: t('transcribing.accessibility.openTranscriptLink'), className: 'ml-05 infobar-interactable infobarButton', icon: IconChatUnread, label: t('transcribing.accessibility.openTranscriptLink'), 
            // eslint-disable-next-line react/jsx-no-bind
            onClick: onClick, size: 'small', type: BUTTON_TYPES.SECONDARY }));
    }
    return null;
};
const mapStateToProps = (state) => {
    return {
        _transcriptionLink: state['features/base/conference'].conference?.transcriptionLink,
        _conference: state['features/base/conference'].conference
    };
};
export default translate(connect(mapStateToProps)(TranscriptLink));
